<div class="flex flex-col p-4" data-testid="discover-menu">
  <div class="flex flex-col gap-3">
    @for (appDescription of appDescriptions$$(); track appDescription) {
      <app-app-launcher-app-tile [appDescription]="appDescription" [attr.data-testid]="appDescription.testId">
      </app-app-launcher-app-tile>
    }
  </div>
</div>
